import { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useProfileV2 } from '#lib/Profile';
import { useFlagsStatus } from '#lib/hooks/useFlag';

export const FirePartnerLogout = () => {
  const { flagsReady } = useFlagsStatus();

  const { logout } = useAuth0();

  const profileContext = useProfileV2();

  useEffect(() => {
    if (!flagsReady) return;

    const anyFirePartners = profileContext.basicProfile?.rootPartnerIds.some(
      (partnerId) => partnerId.startsWith('104') && partnerId.endsWith('_BUSINESSPARTNER'),
    );

    if (anyFirePartners) {
      // Deprecated Fire partners cannot be acted on, so the session is ended
      void logout({ logoutParams: { returnTo: window.location.origin } });
    }
  }, [flagsReady, logout, profileContext]);

  return null;
};
